module.exports = __webpack_public_path__ + "static/media/gibson_mobile.c4d7ec46.png";